const HOUR_IN_MS = 3_600_000;
/**
 * Computes time to next full hour in milliseconds.
 * @returns Milliseconds to the next hour
 */
export const getMilliSecondsToNextHour = () => HOUR_IN_MS - (Date.now() % HOUR_IN_MS);
